export default {
  FORM: {
    CHECKOUT: {
      CHECKOUT: 'Checkout',
      NOTES: 'Notes',
      DELIVERY_DETAIL: 'Delivery Detail',
      DELIVERY_METHOD: 'Delivery Method',
      COURIER: 'Courier',
      DURATION: 'Delivery Duration'
    },
    ACCOUNT: {
      FULL_NAME: 'Full Name',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      EMAIL: 'E-Mail',
      PHONE: 'Phone Number',
      PASSWORD: 'Password',
      CONFIRM_PASSWORD: 'Confirm Password',
      TNC: 'I agree to Terms of Use and Privacy Policy',
      ADDRESS: 'Address',
      POSTAL_CODE: 'Postal Code',
      FIND_LOCATION: 'Find Location',
      PROVINCE: 'Province',
      CITY: 'City'
    },
    CREDENTIAL: {
      OLD_PASSWORD: 'Old Password',
      NEW_PASSWORD: 'New Password'
    },
    BUTTON: {
      SUBMIT: 'Submit',
      CHECKOUT: 'Checkout',
      CANCEL: 'Cancel'
    },
    PROMO: {
      VALID_FROM: 'Valid From',
      VALID_TO: 'Valid Until',
      PRODUCTS: 'Affected Products'
    }
  }
}
